import React, { FC, useMemo } from 'react';
import { ScrollView, StyleSheet, View, Text } from 'react-native';
import PageTitle from '../../components/PageTitle/PageTitle';
import { STYLE_VARS } from '../../constants/style-vars';
import { Footer } from '../../components/Footer';
import ContactUsForm from './components/ContactUsForm';
import ContactItem from './components/ContactItem';
import ContactMultiItem from './components/ContactMultiItem';
import { FONTS } from '../../constants';

const ContactUs: FC = () => {
  const renderContactItem = useMemo(() => {
    const contactData = [
      {
        icon: require('../../assets/address-white.png'),
        title: 'ADDRESS',
        content: "10 COX'S ROAD, KOWLOON, HONG KONG",
      },
      {
        icon: require('../../assets/phone-white.png'),
        title: 'PHONE',
        content: '(852) 3473-7000',
      },
      {
        icon: require('../../assets/fax-white.png'),
        title: 'FAX',
        content: '(852) 2311-1432',
      },
      {
        icon: require('../../assets/email-white.png'),
        title: 'E-MAIL',
        content: 'INFO@KCC.ORG.HK',
      },
    ];
    return contactData.map((content) => (
      <ContactItem
        icon={content.icon}
        title={content.title}
        content={content.content}
        key={content.title}
      />
    ));
  }, []);

  const renderFacilitiesItem = useMemo(() => {
    const facilities = [
      {
        title: 'F & B FUNCTION',
        items: [
          {
            icon: require('../../assets/email-white.png'),
            content: 'SNLADMIN@KCC.ORG.HK',
          },
          {
            icon: require('../../assets/phone-white.png'),
            content: '(852) 3473-7181 OR 3473-7182',
          },
        ],
      },
      {
        title: 'EVENT',
        items: [
          {
            icon: require('../../assets/email-white.png'),
            content: 'EVENTSS@KCC.ORG.HK',
          },
        ],
      },
      {
        title: 'HORSE RACING BOOKINGS',
        items: [
          {
            icon: require('../../assets/email-white.png'),
            content: 'RACEBOX@KCC.ORG.HK',
          },
        ],
      },
      {
        title: 'SPORTS AND RECREATION BOOKINGS/ ENQUIRES',
        items: [
          {
            icon: require('../../assets/email-white.png'),
            content: 'SNLADMIN@KCC.ORG.HK',
          },
          {
            icon: require('../../assets/phone-white.png'),
            content: '(852) 3473-7181 OR 3473-7182',
          },
        ],
      },
      {
        title: 'GROUNDS BOOKINGS',
        items: [
          {
            icon: require('../../assets/email-white.png'),
            content: 'TM@KCC.ORG.HK',
          },
        ],
      },
      {
        title: 'MAGAZINE',
        items: [
          {
            icon: require('../../assets/email-white.png'),
            content: 'MAGAZINE@KCC.ORG.HK',
          },
        ],
      },
    ];
    return facilities.map((content) => (
      <ContactMultiItem
        title={content.title}
        items={content.items}
        key={content.title}
      />
    ));
  }, []);

  const renderDepartmentsItem = useMemo(() => {
    const departments = [
      {
        title: 'MEMBERSHIP / CAR PARK LABELS',
        items: [
          {
            icon: require('../../assets/email-white.png'),
            content: 'MEMBERSHIP@KCC.ORG.HK',
          },
        ],
      },
      {
        title: 'MONTHLY STATEMENT ENQUIRES',
        items: [
          {
            icon: require('../../assets/email-white.png'),
            content: 'FC@KCC.ORG.HK',
          },
        ],
      },
      {
        title: 'RECIPROCAL CLUBS',
        items: [
          {
            icon: require('../../assets/email-white.png'),
            content: 'MEMBERSHIP@KCC.ORG.HK',
          },
        ],
      },
      {
        title: 'COMMENTS',
        items: [
          {
            icon: require('../../assets/email-white.png'),
            content: 'INFO@KCC.ORG.HK',
          },
        ],
      },
    ];
    return departments.map((content) => (
      <ContactMultiItem
        title={content.title}
        items={content.items}
        key={content.title}
      />
    ));
  }, []);

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <PageTitle
          title="CONTACT US"
          icon={require('../../assets/contact-us-icon.png')}
        />
      </View>
      <View style={styles.container}>
        <Text style={[styles.text, { marginTop: 5 }]}>Send online enquiry</Text>
      </View>
      <View style={styles.container}>
        <ContactUsForm
          onSubmitHandler={(data) => {
            console.log(data);
          }}
        />
        <View style={styles.dividerBottom}>
          <View style={{ marginBottom: 10 }}>{renderContactItem}</View>
        </View>
      </View>
      {/* THE CLUB FACILITIES */}
      <View style={styles.container}>
        <View style={styles.dividerBottom}>
          <View style={{ marginTop: 30, marginBottom: 20 }}>
            <View style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
              <View style={{ flexDirection: 'column', alignItems: 'center' }}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <View style={styles.topHeaderLine} />
                  <Text style={styles.topHeaderTitle}>THE CLUB</Text>
                  <View style={styles.topHeaderLine} />
                </View>
                <Text style={styles.bottomHeader}>FACILITIES</Text>
              </View>
            </View>
          </View>
          {renderFacilitiesItem}
        </View>
      </View>
      {/* KCC DEPARTMENT */}
      <View style={[styles.container, { marginBottom: 40 }]}>
        <View style={{ marginTop: 30, marginBottom: 20 }}>
          <View style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
            <View style={{ flexDirection: 'column', alignItems: 'center' }}>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <View style={styles.topHeaderLine} />
                <Text style={styles.topHeaderTitle}>KCC</Text>
                <View style={styles.topHeaderLine} />
              </View>
              <Text style={styles.bottomHeader}>DELPARTMENTS</Text>
            </View>
          </View>
        </View>
        {renderDepartmentsItem}
      </View>
      <Footer />
    </ScrollView>
  );
};

export default ContactUs;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  text: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 14,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
  },
  topHeaderLine: {
    width: 18,
    height: 0.5,
    backgroundColor: STYLE_VARS.kccBgGreen,
  },
  topHeaderTitle: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 13,
    color: STYLE_VARS.primaryColor,
    textTransform: 'uppercase',
    marginStart: 4,
    marginEnd: 4,
  },
  bottomHeader: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 15,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    marginBottom: 2,
  },
  dividerBottom: {
    paddingBottom: 10,
    borderBottomColor: STYLE_VARS.fccDarkGrey,
    borderBottomWidth: 0.5,
  },
});
